import React from 'react'
import PropTypes from 'prop-types'
import MediaUtilityService from "common/services/MediaUtilityService"

import styles from './style.css.scss'

const UserItemImage = ({ user }) => {
  const imgUrl = MediaUtilityService.getImageUrl({
    image: {url: user.image},
    transformation: {
      width: styles.authorImageSize,
      height: styles.authorImageSize,
      ...{crop: "fit"}
    }
  })

  const [imageStyle, imageClassName] = user.image ?
    [{backgroundImage: `url('${imgUrl}')`}, 'background-image'] :
    [{backgroundImage: 'none'}, 'icon-nav-avatar-user']

  return (
    <div
      className={`user-image ${imageClassName}`}
      style={imageStyle} />
  )
}

UserItemImage.propTypes = {
  user: PropTypes.object
}

UserItemImage.defaultProps = {
  user: {}
}

export default UserItemImage